import { ASSETS } from './utils';
import { downloadUrl } from './actions';
import { setFileUrls } from './longhornThemeSlice';
import store from '@cp/src/store';

const downloadAssetsFromFirestore = () => {
  ASSETS.forEach(async (asset, key) => {
    const url = await downloadUrl(asset.fileName);
    store.dispatch(setFileUrls({ [asset.key]: url }));
  });
};

export default downloadAssetsFromFirestore;
